import { useRef } from 'react';

/**
 * Returns the given data, unless it's `undefined`--then returns the last
 * non-`undefined` data it's seen (or `undefined` if that's all it's seen so
 * far). Useful for filtering query results through to keep older results on the
 * screen while a new query is running.
 */
export const useSticky = <T>(data: T): T => {
  const dataRef = useRef(data);
  if (typeof data !== 'undefined') {
    dataRef.current = data;
  }
  return dataRef.current;
};
